export const MODULE_KEYS = [
  "tenant_admin",
  "core_crm",
  "website",
  "member_portal",
  "membership",
  "groups",
  "events",
  "event_checkin",
  "services",
  "sms_messaging",
  "email_messaging",
  "commerce",
  "sermons_media",
  "devotionals",
  "advanced_reporting",
  "multi_campus",
  "api_access",
  "webhooks",
  "integrations",
  "custom_workflows",
] as const;
export type ModuleKey = (typeof MODULE_KEYS)[number];
export type ModuleStatus = "planned" | "beta" | "active" | "deprecated" | "retired";
export type ModuleCategory =
  "core" | "people" | "operations" | "communications" | "commerce" | "platform";
